module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "a-switch",
    class: {
      'a-switch--dark': _vm.onDark
    }
  }, [_c('input', {
    staticClass: "a-switch__input",
    attrs: {
      "autocomplete": "off",
      "type": "radio",
      "name": "view",
      "value": "",
      "id": _vm.id[0],
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "a-switch__label a-switch__label--off",
    class: {
      'a-switch__label--dark': _vm.onDark
    },
    attrs: {
      "for": _vm.id[0]
    }
  }, [_vm._v(_vm._s(_vm.labels[0]))]), _vm._v(" "), _c('input', {
    staticClass: "a-switch__input",
    attrs: {
      "autocomplete": "off",
      "type": "radio",
      "name": "view",
      "value": "",
      "id": _vm.id[1]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "a-switch__label a-switch__label--on",
    class: {
      'a-switch__label--dark': _vm.onDark
    },
    attrs: {
      "for": _vm.id[1]
    }
  }, [_vm._v(_vm._s(_vm.labels[1]))]), _vm._v(" "), _c('span', {
    staticClass: "a-switch__selection"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a8afca42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/SwitchButton.vue
// module id = 1787
// module chunks = 0